import React from "react";
import { useTranslation } from "react-i18next";
import ThermalReceipt from "../../../../Components/GeneralComponents/ThermalReceipt";

const money = (value) => `${Number(value || 0).toFixed(0)} AFN`;

const Print = ({ labTest }) => {
  const { t } = useTranslation();
  const direction = localStorage.getItem("direction");

  return (
    <ThermalReceipt
      direction={direction}
      clinicName={t("print.turkishClinic")}
      phone={`${t("print.phone")}: ${t("print.phoneNumber")}`}
      address={t("print.address")}
      rows={[
        { label: `${t("print.patientName")}:`, value: labTest?.patient_display?.name || "-" },
        { label: `${t("print.age")}:`, value: labTest?.patient_display?.age || "-" },
        { label: `${t("print.gender")}:`, value: labTest?.patient_display?.gender || "-" },
      ]}
      totals={[{ label: t("print.totalAmount"), value: money(labTest?.total_amount), bold: true }]}
      footerLines={[t("print.thanks"), t("print.getWellSoon"), t("print.cosmos")]}
    />
  );
};

export default Print;
